"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
    glyph: "icon_bearbeiten_18x18",
    size: "18",
    style: {
      fill: 'rgba(0, 145, 187, 1)',
      cursor: 'pointer'
    },
    qaId: "ano-meter-form__edit-icon",
    onClick: function onClick() {
      sessionStorage.setItem('usePrefill', '1');
      props.paginate();
    }
  });
};
var _default = exports.default = EditIcon;